export default __webpack_public_path__ + "static/media/30day.51ba79da.png";